let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gNC9e")).then(() => parcelRequire('3eQYY'));